import React from 'react'
import { PaginaNode, useInteresseUtenteQuery } from '@gql/graphql'
import { JsonLd } from '@components/atoms'
import {
  LandingNewsletterAdvForm,
  LandingNewsletterGiardinaggioMiniguidaForm,
  LandingNewsletterHead,
  LandingNewsletterHeader,
  LandingNewsletterRegistrationForm,
  Page,
} from 'components/organisms'
import styles from './LandingNewsletterTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const LandingNewsletterTemplate = (props: Props) => {
  const { pagina } = props

  const { data } = useInteresseUtenteQuery()

  return (
    <Page
      pagina={pagina}
      headerVersion={pagina?.chiave !== 'registrazione-newsletter' ? 'none' : 'default'}
      footerVersion="none"
      className={`${styles.root}`}
    >
      {pagina?.chiave !== 'registrazione-newsletter' && <LandingNewsletterHeader />}
      <main
        className={`${styles.main} ${
          pagina?.chiave === 'registrazione-newsletter' && styles.registration
        }`}
      >
        <LandingNewsletterHead pagina={pagina} />
        {pagina.chiave === 'landing-newsletter-adv' && <LandingNewsletterAdvForm />}
        {pagina.chiave === 'landing-newsletter-giardinaggio-miniguida' && (
          <LandingNewsletterGiardinaggioMiniguidaForm interessiUtente={data?.interessiUtente} />
        )}
        {pagina.chiave === 'registrazione-newsletter' && <LandingNewsletterRegistrationForm />}
      </main>
      <JsonLd type="organization" />
    </Page>
  )
}

export default LandingNewsletterTemplate
